<template>
  <div class="text-truncate">
    {{ data.value | currencyFormat }}
  </div>
</template>

<script>
import BaseCellType from './Base.vue'

export default {
  name: 'CurrencyCellType',
  extends: BaseCellType,
}
</script>

<style scoped>

</style>
